module.exports = __webpack_public_path__ + "static/media/vancouver-mobile.65dc3fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/vancouver-mobile.png
// module id = 983
// module chunks = 0